
import React, { useState } from 'react';
import axios from 'axios';

const ModalDeleteFile = ({ isVisible, onClose, nameFile, onDeleted }) => {
    // const [datas, setDate] = useState([])
    const [programs, setPrograms] = useState([]);
    if( !isVisible ) return null;

    // Ferme le modal en réinitialisant l'éventuelle liste "Forbidden" (sinon elle ré-apparaît
    // à la prochaine ouverture pour un autre fichier).
    const close = () => { setPrograms([]); onClose(); };

    const handleClose = (e) => {
        if(e.target.id === "wrapper") close();
    }

    // console.log(`HERE id is ${nameFile}`);
    let token = localStorage.getItem("token");

    const headers = {
        'x-access-token': token,
        'Content-Type': 'application/json'
    };

    const fileDelete = {
        "nameFile": nameFile
    }

    const handleDelete = () => {
        axios.post(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/deleteFile`, fileDelete, { headers })
        .then(res => {
            if(res.data.message === "Forbidden"){
                setPrograms(res.data.programmeArray)
                // console.log(datas);  
            }else if(res.data.message === "Success"){
                // Rafraîchissement EN PLACE (plus de window.location.reload : il faisait perdre le
                // scroll, le filtre "inutilisés" et le tri). Le parent retire la ligne de son état.
                if (onDeleted) onDeleted(nameFile);
                close();
            }
        }).catch(err => console.log(err))
    }
    
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm" id="wrapper" onClick={handleClose}>
            <div className="max-h-[85vh] w-full max-w-lg overflow-y-auto rounded-2xl bg-white shadow-2xl">
                <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
                    <h2 className="text-lg font-semibold text-slate-800">Confirmer la suppression</h2>
                    <button className="text-slate-400 hover:text-slate-600" onClick={() => close()}>✕</button>
                </div>
                <div className="p-6">
                    <p className="mb-6 text-sm text-slate-600">Voulez-vous vraiment supprimer ce fichier ? Cette action est irréversible.</p>
                    <div className="flex justify-end gap-2">
                        <button type="button" className="rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50" onClick={() => close()}>Annuler</button>
                        <button type="button" className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700" onClick={handleDelete}>Supprimer</button>
                    </div>
                    {programs.length > 0 && (
                        <div className="mt-6 rounded-lg border border-slate-200 bg-slate-50 p-4">
                            <h4 className="mb-2 text-sm font-semibold text-slate-700">Vidéos utilisées dans les programmes suivants :</h4>
                            <ul className="list-inside list-disc text-sm text-slate-600">
                                {programs.map((program, index) => (
                                    <li key={index}>{program}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ModalDeleteFile;